import { v4 as uuidv4 } from 'uuid';

import HaspObject from './HaspObject';
import CustomRect from '../draw/CustomRect';
import {
    resolveSwitchKnobPadding,
    switchKnobBounds,
    switchValueFromBounds,
} from './switchGeometry.js';

export default class HaspSwitch extends HaspObject {
    // hassTemplate = '/media/templates/button.ftl';

    constructor(config) {
        super(config);
        this.hasp_enabled = true;

        const indicator = this.style('indicator');
        const knob = this.style('knob');
        const initialBounds = this.knobBoundsAt(this.val);

        this.indicator = new CustomRect({
            id: uuidv4(),
            x: 0,
            y: 0,
            width: this.width(),
            height: this.height(),
            cornerRadius: indicator.radius,
            fill: indicator.bg_color,
            obj: "indicator",
            draggable: false,
            listening: false,
            stroke: indicator.border_color ?? '#000000',
            borderWidth: indicator.border_width,
        });

        this.knob = new CustomRect({
            id: uuidv4(),
            x: initialBounds.x,
            y: initialBounds.y,
            width: initialBounds.width,
            height: initialBounds.height,
            cornerRadius: knob.radius,
            fill: knob.bg_color,
            obj: "knob",
            draggable: true,
            listening: true,
            stroke: knob.border_color ?? '#000000',
            borderWidth: knob.border_width,
        });

        //enables the button to change thye value
        this.knob.on('dragmove', (e) => {
            this.updateKnob();
        });

        this.on('transform', function () {
            this.syncKnobFromValue();
        });

        this.on('transformend', () => {
            this.syncKnobFromValue();
            this.size(this.rect.size());
        });

        this.on('data_val', () => this.syncKnobFromValue());

        for (const part of ['indicator', 'knob']) {
            for (const prop of ['bg_color', 'bg_grad_color', 'bg_grad_dir', 'bg_main_stop', 'bg_grad_stop']) {
                this.onStyle(part, prop, () => {
                    this.applyBackgroundStyle(this[part], part);
                });
            }
        }

        this.onStyle('indicator', 'border_width', () => {
            const width = Number(this.style('indicator').border_width);
            this.indicator.setStrokeWidth?.(width);
            if (!this.indicator.setStrokeWidth) this.indicator.strokeWidth(width);
        })
        this.onStyle('knob', 'border_width', () => {
            const width = Number(this.style('knob').border_width);
            this.knob.setStrokeWidth?.(width);
            if (!this.knob.setStrokeWidth) this.knob.strokeWidth(width);
        })
        this.onStyle('indicator', 'border_color', () => {
            this.indicator.stroke(this.style('indicator').border_color);
        })
        this.onStyle('knob', 'border_color', () => {
            this.knob.stroke(this.style('knob').border_color);
        })
        this.onStyle('indicator', 'radius', () => {
            this.indicator.cornerRadius(this.style('indicator').radius);
        });
        this.onStyle('knob', 'radius', () => {
            this.knob.cornerRadius(this.style('knob').radius);
        });
        for (const prop of ['padding', 'pad_left', 'pad_right', 'pad_top', 'pad_bottom']) {
            this.onStyle('knob', prop, () => this.syncKnobFromValue());
        }
        this.add(this.indicator);
        this.add(this.knob);
        this.applyBackgroundStyle(this.indicator, 'indicator');
        this.applyBackgroundStyle(this.knob, 'knob');
        this.draggable(true);

        this.syncKnobFromValue();
    }

    setNewSize(size) {
        super.setNewSize(size);
        this.syncKnobFromValue();
    }

    knobPads() {
        return resolveSwitchKnobPadding(this.style('knob'));
    }

    knobBoundsAt(value) {
        return switchKnobBounds({
            value,
            width: this.rect.width(),
            height: this.rect.height(),
            ...this.knobPads(),
        });
    }

    applyKnobBounds(bounds) {
        this.knob.x(bounds.x);
        this.knob.y(bounds.y);
        this.knob.width(bounds.width);
        this.knob.height(bounds.height);
    }

    updateKnob() {
        const pads = this.knobPads();
        this.val = switchValueFromBounds({
            x: this.knob.x(),
            width: this.rect.width(),
            height: this.rect.height(),
            ...pads,
        });
        this.syncKnobFromValue();
        this.idTextObj.moveToTop();
    }

    syncKnobFromValue() {
        const value = Number(this.val) > 0 ? 1 : 0;
        this.val = value;
        this.applyKnobBounds(this.knobBoundsAt(value));
        this.indicator.size({ width: this.rect.width(), height: this.rect.height() })
        this.knob.cornerRadius(this.style('knob').radius);
        this.indicator.cornerRadius(this.style('indicator').radius);
        this.indicator.visible(value > 0);
        this.idTextObj.moveToTop();
    }
}
